/*
 * サブシステム名：
 * 機能名：受注・実績一覧
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdMonthBox from '@/components/DdMonthBox'
import DdSearchList from '@/components/DdSearchGrid'
import DdTextBox from '@/components/DdTextBox'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
// import indexeddb from '@/ddv2.library/indexeddb'
// import modals from '@/ddv2.library/modals'

import flowMixin from '@/mixins/flowMixins'
// import validators from '@/rahmen/validators'

import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

export default {
  name: 'PrmHaishaList',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdCodeTextBox,
    DdMonthBox,
    DdSearchList,
    DdTextBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 50,
    page: 1,
    isCsvDownloader: false,
    isExcelDownloader: false,

    // 検索条件
    params: {},
    conditions: {
      unkoYoteiStartYmdString: null,
      unkoYoteiEndYmdString: null,
      haishaEigyoshoId: null,
      tokuisakiId: null,
      hacchusakiId: null,
      jininId1: null,
      sharyoId: null,
      meisaiHeadFlg: false
    },
    conditionDetails: [
      { key: 'targetMonth', name: '対象年月', value: 'targetMonth', type: 'value', delete: false, showValue: true, convertValue: false },
      { key: 'juchuEigyoshoId', name: '売上営業所', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msteigyosho' },
      { key: 'tokuisakiId', name: '荷主', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msttorihikisaki' },
      { key: 'hacchusakiId', name: '傭車先', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'msttorihikisaki' },
      { key: 'jininId1', name: '乗務員', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'mstjinin' },
      { key: 'sharyoId', name: '車両', value: null, type: 'value', delete: true, showValue: true, convertValue: true, master: 'mstsharyo' }
    ],

    // 検索結果
    rows: [],

    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstSharyoHeaders: header.mstSharyoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,

    // 権限
    modeKengen: 0,

    // AG-Gridオプション
    customGridOptions: {
      domLayout: 'normal',
      pagination: true,
      paginationPageSize: 50,
      tooltipShowDelay: 0
    }
  }),
  watch: {
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      sharyoList: 'DDMasters/vwCMstSharyo',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd',
      userSettings: 'DDMasters/mstUserSettings',
      helpUseFlg: 'users/helpUseFlg',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    viewStyleType () {
      const type = [undefined, null].includes(this.userSettings) || [undefined, null].includes(this.userSettings.useNippoEditType) ? 1 : this.userSettings.useNippoEditType
      return type
    },
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        const date = new Date(filter.dateFormatter(elem.sagyoYmd).replaceAll('/', '-')) // 任意の日付
        const days = ['日', '月', '火', '水', '木', '金', '土']
        const dayOfWeek = days[date.getDay()] // 0(日)〜6(土)

        elem.day = Number(((filter.dateFormatter(elem.sagyoYmd)).split('/'))[2])
        elem.weekday = dayOfWeek
        elem.uriageKingakuSum = elem.jishaUriageKingakuSum + elem.yoshaUriageKingakuSum
        elem.keihiGokei = (elem.yoshaShiharaiKingakuSum ?? 0) + (elem.nenryohi ?? 0) + (elem.kotsuhi ?? 0) + (elem.sonotaKeihi ?? 0)

        if (elem.day === 27) {
          console.log('debug')
        }

        const rieki = elem.uriageKingakuSum - elem.keihiGokei
        if (elem.uriageKingakuSum !== 0) {
          elem.riekiRitsu = (rieki / elem.uriageKingakuSum * 100).toFixed(2)
        } else if (elem.uriageKingakuSum === 0 && elem.keihiGokei > 0) {
          elem.riekiRitsu = 0
        }
        elem.yoshaRitsu = (elem.yoshaUriageKingakuSum === 0 ? 0 : (elem.yoshaUriageKingakuSum / elem.uriageKingakuSum) * 100).toFixed(2)
        elem.tooltipText = `${elem.day}日の詳細画面に遷移します`
        elem.genkaiRieki = rieki

        return elem
      }).sort((a, b) => {
        if (a.unkoYmd > b.unkoYmd) { return -1 }
        if (a.unkoYmd === b.unkoYmd) {
          if (a.trUnkoJissekiId > b.trUnkoJissekiId) { return -1 }
          if (a.trUnkoJissekiId === b.trUnkoJissekiId) {
            if (a.meisaiOrder > b.meisaiOrder) { return 1 }
            if (a.meisaiOrder === b.meisaiOrder) { return 0 }
            return -1
          }
          return 0
        }
        return 1
      })
    },

    // ------------------------------------------------------------
    // マスタ
    // ------------------------------------------------------------
    // 営業所フィルター
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      })
    },
    // 人員フィルター
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      const self = this
      return this.eigyoshoJininList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03' && (self.eigyoshoLockFlg || elem.eigyoshoCd === self.usersEigyoshoCd)
      })
    },
    // 取引先フィルター
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    // 得意先フィルター
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.tokuisakiFlg === true
      })
    },
    // 傭車先フィルター
    filteredMstHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.hacchusakiFlg === true
      })
    },
    // 車両マスタフィルター
    filteredMstSharyoList () {
      const target = filter.dateFormatter(new Date())
      const self = this
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.hacchusakiFlg === false && (self.eigyoshoLockFlg || elem.eigyoshoCd === self.usersEigyoshoCd)
      })
    },

    // ------------------------------------------------------------
    // 表示制御
    // ------------------------------------------------------------
    // CSVボタン活性条件
    isCsvButtonDisabled () {
      return this.rows.length === 0 || this.isCsvDownloader
    },
    // Excelボタン活性条件
    isExcelButtonDisabled () {
      return this.rows.length === 0 || this.isExcelDownloader
    },
    isEditButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      if (this.selected.length === 1) {
        return false
      }
      return true
    },

    // ------------------------------------------------------------
    // 起動パラメータ有無
    // ------------------------------------------------------------
    isNoParam () {
      return Object.keys(this.params).length === 0
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    getNextTransition: function () {
      const nextTransition = ![undefined, null].includes(this.userSettings.useNippoEditTransition) ? this.userSettings.useNippoEditTransition : 1
      return nextTransition
    },
    initialize () {
      console.log('initialize')
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'msttorihikisaki', 'vwcmstsharyo', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('PrmHaishaList.defineHeaderPromise')
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('PrmHaishaList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('PrmHaishaList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('PrmHaishaList.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('PrmHaishaList.restoreViewPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
              self.searchText = c.cache.value.searchText || ''
              self.rows = c.cache.value.rows || []
            }
            resolve()
          })
        },
        settingViewScroll: () => {
          return false
        },
        settingButtonStatePromise: (kengen) => {
          console.log('PrmHaishaList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonIgnition: function (e) {
      this.$refs.ddSearchList.onSearchButtonClick()
    },
    onSearchButtonClick: function (e) {
      this.rows = []
      this.selected = []
      this.page = 1

      // ヘッダ作成
      this.setHeader()

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2bzmd0130/aggregateSearch', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            meisaiHeadFlg: self.conditions.meisaiHeadFlg
          }
        }
      }
      this.search(opt)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      this.conditions = {
        targetMonth: (date.getCurrentDate()).substr(0, 7)
      }
      this.searchText = ''
      this.rows = []
      this.page = 1
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.initBindVariables()
            self.$refs.ddSearchList.showConditionArea()
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onRemoveConditionClick: function (itemNm, type) {
      if (type === 'checkbox') {
        this.conditions[itemNm] = false
      } else {
        this.conditions[itemNm] = null
      }
    },
    onRowDoubleClick: function (e) {
      console.log(e)
      // alert(`AG-GRID DOUBLE CLICK ${this.conditions.targetMonth} ${e.day}`)
      const [year, month] = this.conditions.targetMonth.split('/')
      const day = String(e.day).padStart(2, '0')
      const fullDate = `${year}/${month}/${day}`
      var param = {
        sagyoYmd: fullDate,
        sagyoEigyoshoId: this.conditions.sagyoEigyoshoId,
        tokuisakiId: this.conditions.tokuisakiId,
        jininId1: this.conditions.jininId1,
        sharyoId: this.conditions.sharyoId,
        hacchusakiId: this.conditions.hacchusakiId
      }
      this.Effects.loadStart()
      this.transition(1, param)
    },

    // 検索前チェック
    searchValidate: function () {
      return true
    },
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      // this.$set(this, 'itemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },

    // ------------------------------------------------------------------
    // AG-GRID用
    // ------------------------------------------------------------------
    setHeader () {
      this.headers = [
        {
          headerName: `${this.conditions.targetMonth}`,
          headerClass: 'title-header',
          children: [
            {
              headerName: '日付',
              field: 'day',
              tooltipField: 'tooltipText',
              filter: false,
              width: 50,
              cellStyle: { textAlign: 'right' },
              cellRenderer: params => {
                const val = Number(params.value)
                return isNaN(val) ? '' : `<a class="date-link" @click="onCellClicked()">${val}日</a>`
              },
              onCellClicked: params => {
                if (params.event.target?.matches('a.date-link')) {
                  // alert(`クリックされた日付: ${params.data.day}`)
                  this.onRowDoubleClick(params.data)
                }
              }
            },
            {
              headerName: '曜日',
              field: 'weekday',
              filter: false,
              sortable: false,
              width: 50,
              cellStyle: { textAlign: 'center' },
              cellClassRules: {
                'weekday-saturday': (params) => params.value === '土',
                'weekday-sunday': (params) => params.value === '日'
              }
            }
          ]
        },
        {
          headerName: '収益',
          children: [
            {
              headerName: '利益率',
              headerClass: 'revenue-header',
              field: 'riekiRitsu',
              sortable: true,
              width: 80,
              cellStyle: { textAlign: 'right' },
              valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toFixed(2).toLocaleString() + ' ％' },
              cellClassRules: {
                'cell-green': (params) => Number(params.value) >= 50,
                'cell-red': (params) => Number(params.value) < 10
              }
            },
            {
              headerName: '傭車率',
              field: 'yoshaRitsu',
              sortable: true,
              width: 80,
              cellStyle: { textAlign: 'right' },
              valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' ％' }
            },
            { headerName: '総売上額', field: 'uriageKingakuSum', sortable: true, width: 110, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 円' } },
            { headerName: '(自車売上計)', field: 'jishaUriageKingakuSum', sortable: true, width: 110, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 円' } },
            { headerName: '(傭車売上計)', field: 'yoshaUriageKingakuSum', sortable: true, width: 110, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 円' } },
            { headerName: '総経費額', field: 'keihiGokei', sortable: true, width: 110, cellStyle: { textAlign: 'right', color: '#a82323' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 円' } },
            { headerName: '限界利益', field: 'genkaiRieki', sortable: true, width: 110, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 円' } }
          ]
        },
        {
          headerName: '運行詳細',
          children: [
            { headerName: '運行件数', field: 'unkoCount', sortable: true, width: 100, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 件' } },
            { headerName: '(自車数)', field: 'jishaSharyoCount', sortable: true, width: 100, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 件' } },
            { headerName: '(傭車数)', field: 'yoshaSharyoCount', sortable: true, width: 100, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 件' } },
            { headerName: '明細件数', field: 'meisaiCount', sortable: true, width: 100, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 件' } }
          ]
        },
        {
          headerName: '経費内訳',
          children: [
            { headerName: '傭車費', field: 'yoshaShiharaiKingakuSum', sortable: true, width: 110, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 円' } },
            { headerName: '燃料費', field: 'nenryohi', sortable: true, width: 110, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 円' } },
            { headerName: '交通費', field: 'kotsuhi', sortable: true, width: 110, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 円' } },
            { headerName: 'その他経費', field: 'sonotaKeihi', sortable: true, width: 110, cellStyle: { textAlign: 'right' }, valueFormatter: params => { const val = Number(params.value); return isNaN(val) ? '' : val.toLocaleString() + ' 円' } }
          ]
        }
      ]
    },

    onDummyFunction: function () {
      return null
    }
  }
}
